import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createBasket, updateBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { signIn } from '@store/guest/actions';
import { SpaTreatmentContainer } from './SpaTreatmentContainer';
import { yourJourneySelectors } from '@store/yourJourney';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  entityType: 'spa-treatments',
  upSellName: 'spa-treatment',
  defaultTitle: 'SPA_TREATMENT',
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
      signIn,
    },
    dispatch
  );

export const SpaTreatment: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaTreatmentContainer);
